import Add from '@src/assets/svg/add';
import AddSquare from '@src/assets/svg/addSquare';
import FinacialIcon from '@src/assets/svg/financial';
import Doller from '@src/assets/svg/doller';
import ListingDetailWallet from '@src/assets/svg/listingDetailWallet';
import Bar from '@src/assets/svg/bar';
import Share from '@src/assets/svg/share';
import Heart from '@src/assets/svg/heart';
import CircleArrowDown from '@src/assets/svg/circleArrowDown';
import CircleArrowRight from '@src/assets/svg/circleArrowRight';
import Chat from '@src/assets/svg/chat';
import Task from '@src/assets/svg/task';
import Profile from '@src/assets/svg/profile';
import Bell from '@src/assets/svg/bell';
import Varification from '@src/assets/svg/varification';
import ShieldVarification from '@src/assets/svg/shieldVarification';
import DocumentText from '@src/assets/svg/documentText';
import Messages from '@src/assets/svg/messages';
import UserAvatar from '@src/assets/svg/userAvatar';
import LoaderDots from '@src/assets/svg/loaderDots';
import Wallet from '@src/assets/svg/wallet';
import Error from '@src/assets/svg/error';
import CopySuccess from '@src/assets/svg/copySuccess';
import Copy from '@src/assets/svg/copy';
import Location from '@src/assets/svg/location';
import Sms from '@src/assets/svg/sms';
import Call from '@src/assets/svg/call';
import ArrowLeft from '@src/assets/svg/arrowLeft';
import BlueTick from '@src/assets/svg/blueTick';
import EmailSent from '@src/assets/svg/emailSent';
import Facebook from '@src/assets/svg/facebook';
import Instagram from '@src/assets/svg/instagram';
import Tiktok from '@src/assets/svg/tiktok';
import Linkedin from '@src/assets/svg/linkedin';
import Twitter from '@src/assets/svg/twitter';
import Spotify from '@src/assets/svg/spotify';
import LinkExpire from '@src/assets/svg/linkExpire';
import ArrowRight from '@src/assets/svg/arrowRight';
import Cross from '@src/assets/svg/cross';
import TickCircle from '@src/assets/svg/tickCircle';
import SendSqaure from '@src/assets/svg/sendSqaure';
import Refresh from '@src/assets/svg/refresh';
import ArrowDown from '@src/assets/svg/arrowDown';
import SendInvite from '@src/assets/svg/sendInvite';
import CrossIcon from '@src/assets/svg/crossIcon';
import NoResultFound from '@src/assets/svg/noResult';
import HeartNotFill from '@src/assets/svg/heartNotFill';
import HeartFill from '@src/assets/svg/heartFill';
import CreditCheck from '@src/assets/svg/creditCheck';
import People from '@src/assets/svg/people';
import Pets from '@src/assets/svg/pets';
import Sidebar from '@src/assets/svg/sidebar';
import HomeKey from '@src/assets/svg/homeKey';
import Ordering from '@src/assets/svg/ordering';
import Settings from '@src/assets/svg/setting';
import ZemeBetaLogo from '@src/assets/svg/zemeBetaLogo';
import Download from '@src/assets/svg/download';
import CheckBullets from '@src/assets/svg/checkBullets';
import CardPos from '@src/assets/svg/cardPos';
import CardTick from '@src/assets/svg/cardTick';
import UserSquare from '@src/assets/svg/userSquare';
import ProfileAdd from '@src/assets/svg/profileAdd';
import GPay from '@src/assets/svg/gpay';
import ApplePay from '@src/assets/svg/applePay';
import Trash from '@src/assets/svg/trash';
import Document from '@src/assets/svg/document';
import CopyTwo from '@src/assets/svg/copyTwo';
import ChatTwo from '@src/assets/svg/chatTwo';
import Info from '@src/assets/svg/info';
import HomeTradeUp from '@src/assets/svg/homeTradeUp';
import TagUser from '@src/assets/svg/tagUser';
import UserTick from '@src/assets/svg/userTick';
import CrossFill from '@src/assets/svg/crossFill';
import TickCircleFill from '@src/assets/svg/tickCircleFill';
import AiMarketing from '@src/assets/svg/aiMarketing';
import SmsNotification from '@src/assets/svg/smsNotification';
import InfoCircle from '@src/assets/svg/infoCircle';
import Notes from '@src/assets/svg/notes';
import Notes2 from '@src/assets/svg/notes2';
import InfoCircleWhite from '@src/assets/svg/infoCircleWhite';
import MultiBuildings from '@src/assets/svg/multiBuildings';
import ExlamationTriangle from '@src/assets/svg/exlamationTriangle';
import Tag from '@src/assets/svg/tag';
import Search from '@src/assets/svg/search';
import Pencil from '@src/assets/svg/pencil';
import Pencil2 from '@src/assets/svg/pencil2';
import RenterHistory from '@src/assets/svg/rentelHistory';
import PhotoId from '@src/assets/svg/photoId';
import KidsPets from '@src/assets/svg/kidsPets';
import ReceiptPro from '@src/assets/svg/receiptPro';
import VerifiedFinancialsPlace from '@src/assets/svg/verifiedFinancialsPlace';
import MoneySend from '@src/assets/svg/moneySend';
import Building from '@src/assets/svg/building';
import PersonalCard from '@src/assets/svg/personalCard';
import SimCard2 from '@src/assets/svg/simCard';
import TaskSquare from '@src/assets/svg/taskSquare';
import Card from '@src/assets/svg/card';
import Computing from '@src/assets/svg/computing';
import Teacher from '@src/assets/svg/teacher';
import Briefcase from '@src/assets/svg/briefcase';
import KeySquare from '@src/assets/svg/keySquare';
import DollarSquare from '@src/assets/svg/dollarSquare';
import { Letter } from '@src/assets/svg/letter';
import Reciept2 from '@src/assets/svg/recieptItem';
import Back from '@src/assets/svg/back';
import Email from '@src/assets/svg/email';
import ZoomIn from '@src/assets/svg/zoomIn';
import ZoomOut from '@src/assets/svg/zoomOut';

// Icon list
// Note: if someone from dev has added any new icon then please add it here.
const iconList = {
  add: Add,
  addSquare: AddSquare,
  financialIcon: FinacialIcon,
  doller: Doller,
  listingDetailWallet: ListingDetailWallet,
  bar: Bar,
  share: Share,
  heart: Heart,
  circleArrowDown: CircleArrowDown,
  circleArrowRight: CircleArrowRight,
  profile: Profile,
  task: Task,
  bell: Bell,
  varification: Varification,
  shieldVarification: ShieldVarification,
  document: Document,
  documentText: DocumentText,
  messages: Messages,
  userAvatar: UserAvatar,
  lodaerdots: LoaderDots,
  wallet: Wallet,
  error: Error,
  copySuccess: CopySuccess,
  copy: Copy,
  copyTwo: CopyTwo,
  location: Location,
  call: Call,
  sms: Sms,
  arrowLeft: ArrowLeft,
  blueTick: BlueTick,
  emailSent: EmailSent,
  email: Email,
  facebook: Facebook,
  instagram: Instagram,
  tiktok: Tiktok,
  linkedin: Linkedin,
  twitter: Twitter,
  spotify: Spotify,
  linkExpire: LinkExpire,
  arrowRight: ArrowRight,
  cross: Cross,
  tickcircle: TickCircle,
  sendsqaure: SendSqaure,
  refresh: Refresh,
  arrowdown: ArrowDown,
  sendinvite: SendInvite,
  crossicon: CrossIcon,
  noresultfound: NoResultFound,
  heartnotfill: HeartNotFill,
  heartfill: HeartFill,
  creditcheck: CreditCheck,
  people: People,
  pets: Pets,
  sidebar: Sidebar,
  homekey: HomeKey,
  chat: Chat,
  chatTwo: ChatTwo,
  ordering: Ordering,
  settings: Settings,
  zemebetalogo: ZemeBetaLogo,
  download: Download,
  checkbullets: CheckBullets,
  cardPos: CardPos,
  cardtick: CardTick,
  userquare: UserSquare,
  profileAdd: ProfileAdd,
  gpay: GPay,
  applePay: ApplePay,
  trash: Trash,
  pencil: Pencil,
  pencil2: Pencil2,
  info: Info,
  homeTradeUp: HomeTradeUp,
  tagUser: TagUser,
  userTick: UserTick,
  crossFill: CrossFill,
  tickCircleFill: TickCircleFill,
  aiMarketing: AiMarketing,
  smsNotification: SmsNotification,
  infoCircle: InfoCircle,
  notes: Notes,
  notes2: Notes2,
  infoCircleWhite: InfoCircleWhite,
  multiBuildings: MultiBuildings,
  exlamationTriangle: ExlamationTriangle,
  tag: Tag,
  searchIcon: Search,
  credit_check: CreditCheck,
  renter_history: RenterHistory,
  photo_id: PhotoId,
  tag_user: PhotoId,
  kid_and_pet: KidsPets,
  receipt_2: Reciept2,
  bank: VerifiedFinancialsPlace,
  money_send: MoneySend,
  document_text: Document,
  buildings: Building,
  personalcard: PersonalCard,
  simcard_2: SimCard2,
  task_square: TaskSquare,
  card: Card,
  computing: Computing,
  teacher: Teacher,
  briefcase: Briefcase,
  key_square: KeySquare,
  dollar_square: DollarSquare,
  receipt_item: ReceiptPro,
  letter: Letter,
  back: Back,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,
};

export { iconList };
